import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { PacoteTarifa } from '../../model';

import { GERENCIAMENTO, ITENSPORPAGINA } from '../../app.config';

@Injectable()
export class PacoteTarifaService{

  constructor(private http: HttpClient){}


    buscarPorParametro(param: string, pagina: Number): Observable<any>
    {
      const headers = new HttpHeaders().set('noloader', 't');
      if (param.length > 0)
      {
        return this.http.get<any>( `${GERENCIAMENTO}/api/PacoteTarifa/list/${param.trim()}?Pagina=${pagina}&ItensPorPagina=${ITENSPORPAGINA}`, {headers: headers});
      }
      else
      {
        return this.http.get<any>( `${GERENCIAMENTO}/api/PacoteTarifa?Pagina=${pagina}&ItensPorPagina=${ITENSPORPAGINA}`, {headers: headers});
      }
    }

    buscarPorId(id: number): Observable<any>
    {
        return this.http.get<any>( `${GERENCIAMENTO}/api/PacoteTarifa/${id}?Pagina=1&ItensPorPagina=${ITENSPORPAGINA}`);
    }

    remover(id: Number): Observable<any>
    {
      return this.http.delete<any>( `${GERENCIAMENTO}/api/PacoteTarifa/${id}`);
    }

    salvar(PacoteTarifa: PacoteTarifa): Observable<any>{
      if (PacoteTarifa.Id > 0)
      {
        return this.http.put<any>( `${GERENCIAMENTO}/api/PacoteTarifa/${PacoteTarifa.Id}`, PacoteTarifa);
      }
      else
      {
        return this.http.post<any>( `${GERENCIAMENTO}/api/PacoteTarifa/`, PacoteTarifa);
      }

    }

  }
